import { dataFormatters } from "../../../utils/dataFormatters";

const getTableValues = (data, keyAs) => {
  let records = [];
  if (data && Array.isArray(data)) {
    records = data
      .filter((d) => d)
      .filter((d) => !d.removed) // if it hasn't been soft deleted
      .filter((d) => JSON.stringify(d) !== "{}")
      .filter((d) => d.form)
      .map((d) => {
        return getFormSummary(d, keyAs);
      });
  }
  return records;
};

/**
 *
 * @param {string} labelAndId combined label and id joined by _____
 * @returns {[string, string]} splits labelAndId on _____ and returns label and id separately
 */
export const getFormSummaryPropLabelAndKey = (labelAndId) => {
  return labelAndId.split("_____");
};

/**
 *
 * @param {object} appForm original appForm structure received from the backend
 * @param {"id" | "label" | "labelAndId"} useKeyAs use the key as fieldId or fieldLabel or a fieldLabel_____fieldId
 * @param {boolean} keyAsDict use the key as a
 * @returns key-val pairs
 */
export const getFormSummary = (appForm, keyAs = "id") => {
  let form = appForm.form;
  if (!form) {
    form = appForm["*form"];
  }
  if (!form) return;

  return form
    .filter((item) => item && item.id)
    .reduce((result, item) => {
      let value = "";
      switch (item.type) {
        case "checkbox":
          value = item.value === "true" || item.value === true ? true : false;
          break;
        case "table":
          value = getTableValues(item.value, keyAs);
          break;
        case "date":
          value = dataFormatters.dateFormatter(item.value);
          break;
        case "datetime":
          value = dataFormatters.dateTimeFormatterWithoutSecs(item.value);
          break;
        default:
          value = item.value;
          break;
      }
      let _id = item.altId ? item.altId : item.id;
      if (keyAs === "label" && item.name) {
        result[item.name] = value;
      } else if (keyAs === "labelAndId") {
        result[`${item.name}_____${_id}`] = value;
      } else {
        if (item.altId) {
          let existingValue = result[_id];
          if (!existingValue) result[_id] = value;
        } else {
          result[_id] = value;
        }
      }

      if (item.type === "date") {
        // add time from data for legacy support
        result[`${_id}___time`] = dataFormatters.timeFormatterWithoutSecs(item.value);
      }
      return result;
    }, {});
};



// WEBPACK FOOTER //
// ./src/components/Reports/utils/getFormSummary.js